let trends = [
    {
        title: "Trend in Algeria",
        hashtag: "#React_is_awsome",
        tweets: 4523
    },
    {
        title: "Trend in Algeria",
        hashtag: "#Sass_in_da_house",
        tweets: 3901
    },
    {
        title: "Trend in Algeria",
        hashtag: "#Bleach_back",
        tweets: 1533
    },
    {
        title: "Trend in Algeria",
        hashtag: "#Qbits",
        tweets: 1231
    },
    {
        title: "Trend in Algeria",
        hashtag: "JS_forever",
        tweets: 723
    },
]

export { trends };